import { render } from "./BatchUpload.vue?vue&type=template&id=4ec0dffe&scoped=true"
import script from "./BatchUpload.vue?vue&type=script&lang=js"
export * from "./BatchUpload.vue?vue&type=script&lang=js"

import "./BatchUpload.vue?vue&type=style&index=0&id=4ec0dffe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec0dffe"]])

export default __exports__